/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { postPrintPdf } from '../fn/print/post-print-pdf';
import { PostPrintPdf$Params } from '../fn/print/post-print-pdf';


/**
 * Afgewerkte prints als PDF (docs/superpowers/specs/2026-10-21-chart-pdf-print-design.md). De
 * frontend bouwt de printpagina uit zijn eigen componenten en stuurt ze als zelfstandige HTML;
 * hier wordt die met headless Chrome omgezet. Alleen voor ingelogde gebruikers, met een
 * rate-limit per gebruiker; de renderer begrenst zelf het aantal gelijktijdige renders.
 */
@Injectable({ providedIn: 'root' })
export class PlatformPrintService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postPrintPdf()` */
  static readonly PostPrintPdfPath = '/api/Print/pdf';

  /**
   * Zet een zelfstandig HTML-document om naar PDF. Paginaformaat en marges komen uit de CSS
   * (@page). 503 als de renderer bezet is of te lang doet: de client mag opnieuw proberen.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postPrintPdf()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postPrintPdf$Response(params: PostPrintPdf$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postPrintPdf(this.http, this.rootUrl, params, context);
  }

  /**
   * Zet een zelfstandig HTML-document om naar PDF. Paginaformaat en marges komen uit de CSS
   * (@page). 503 als de renderer bezet is of te lang doet: de client mag opnieuw proberen.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postPrintPdf$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postPrintPdf(params: PostPrintPdf$Params, context?: HttpContext): Observable<Blob> {
    return this.postPrintPdf$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
